import React from 'react';
import { Users } from "lucide-react";

const AboutUsSection = ({ onOpenForm }) => {
  return (
    <section className="py-16 bg-white text-gray-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          {/* Left Content */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-[#741112] uppercase tracking-wider">
              Your Mandate Partner in Real Estate
            </h3>

            <p className="text-gray-700 mb-4">
              REALATION is a dynamic real estate mandate company focused on creating value and driving results for our clients.
            </p>

            <p className="text-gray-700 mb-6">
              We empower our partners by supporting developers with end-to-end sales strategy and execution, and enabling channel partners with the tools, training, and trust they need to thrive.
            </p>

            <p className="text-gray-700 mb-6">
              As one of the fastest-growing real estate marketing and sales firms in the country, we’re built on human potential and a performance-driven approach. In a constantly evolving market, we work closely with our partners to navigate challenges and unlock new opportunities.
            </p>

            <button
              onClick={onOpenForm}
              className="inline-flex items-center bg-[#741112] text-white font-medium px-5 py-3 rounded hover:bg-[#5e0d10] transition"
            >
              Talk to Expert
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 ml-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          {/* Right Image & Badge */}
          <div className="relative">
            <img
              src="assets/about.webp"
              alt="REALATION Team"
              loading="lazy"
              className="rounded-lg object-cover w-full h-auto shadow-xl border border-[#741112]/30"
            />
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-lg border border-[#741112]">
              <div className="text-[#741112] font-extrabold text-5xl leading-tight">3+</div>
              <div className="text-gray-800 text-base font-medium">Years of Experience</div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
